export enum CustomerStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  UNREGISTERED = 'unregistered',
}
